import { Route } from "react-router-dom";
import {
	createReactRouterV5Options,
	getWebInstrumentations,
	initializeFaro,
	ReactIntegration
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

import { API_URL } from "utils/constants";

import { name, version } from "../../package.json";
import config from "../../config.json";

export default function initGrafana(routerHistory){
	if(!config.grafanaURL){
		console.groupCollapsed("%cGrafana startup error!%c", "color: #1a42bf; font-weight:bold; background-color:#0ba8e6; padding:2px", "color:default; font-weight:normal;");
		console.info("Missing %cgrafanaURL%c in config.", "color: #4952e6; font-family:monospace;", "color:default, font-family:default");
		console.groupEnd();
		return;
	}

	try {
		initializeFaro({
			// Mandatory, the URL of the Grafana collector
			url: config.grafanaURL,

			// Mandatory, the identification label of your application
			app: {
				name,
				version,
				environment: config.buildENV,
			},

			instrumentations: [
				// Load the default Web instrumentations
				...getWebInstrumentations(),

				new ReactIntegration({
					// or createReactRouterV4Options
					router: createReactRouterV5Options({
						history:routerHistory,
						// hist, // the history object used by react-router
						Route, // Route component imported from react-router package
					}),
				}),
				new TracingInstrumentation({
					instrumentationOptions: {
						propagateTraceHeaderCorsUrls: [
							new RegExp(API_URL),
						],
					},
				}),
			],
		});
	} catch(err){
		console.group("%cGrafana startup error!%c", "color: #1a42bf; font-weight:bold; background-color:#0ba8e6; padding:2px", "color:default; font-weight:normal;");
		console.error(err);
		console.groupEnd();
	}
}
